<template>
  <address :class="[$style.field, $style.customer]" v-if="hasSelectedProspect">
    <img :src="prospect.photoUrl" :alt="prospect.name" />
    <div>
      <p>{{prospect.name}}</p>
      <p v-if="company || prospect.title">{{prospect.title}}<template v-if="company"> at {{company}}</template></p>
      <p v-if="prospect.type === 'account' && prospect.industry">{{prospect.industry}}</p>
    </div>
  </address>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'

  const { mapState, mapGetters } = createNamespacedHelpers('activitySummary')

  export default {
    computed: {
      ...mapGetters(['hasSelectedProspect']),
      ...mapState(['activity']),
      ...mapState({ prospect: 'selectedProspect' }),
      company () {
        const { type, account, company } = this.prospect

        switch (type) {
          case 'lead':
            return company
          case 'contact':
            return account ? account.name : null
          default:
            return null
        }
      }
    }
  }
</script>

<style module lang="less" src="./customer.less"></style>



// WEBPACK FOOTER //
// customer.vue?ba78696e